import { Component, Input } from '@angular/core';

@Component({
  selector: 'sr-psa-govco-footer',
  standalone: true,
  templateUrl: './govco-footer.component.html',
  styleUrl: './govco-footer.component.css'
})
export class GovcoFooterComponent {
  @Input() projectLayout = false;
}
